module.exports = __webpack_public_path__ + "static/7-bb7a28ce8539d4f746a61bec6a25f415.png";